import axios, { AxiosRequestConfig } from 'axios';
import { IDataInput } from '../interface/interfaces';
import { Methods } from '../constants/constants';

export const fetchProtectedData = <T extends IDataInput>(method: Methods, input: T, isProtected: boolean, hasURLRoot: boolean, isChat: boolean) => {
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        // 'x-api-key': '4a5QryLHhxEAfp67VSP5'
    };

    if (isProtected) {
        headers['Authorization'] = `Bearer ${input.token}`;
    }

    if (isChat) {
        headers['accept'] = 'application/json';
        headers['Authorization'] = `Bearer ${process.env.REACT_APP_CHAT_TOKEN}`;
    }

    const config: AxiosRequestConfig = {
        headers,
        method,
        url: !hasURLRoot ? `${process.env.REACT_APP_USER_API}/${input.url}` : `${input.url}`,
    };

    if (method !== Methods.GET && 'body' in input) {
        config.data = input.body;
    }

    return axios(config);
};
